/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Publisher } from '../../models/publisher';

export interface GetPublisher$Params {
  id: string;
}

export function getPublisher(http: HttpClient, rootUrl: string, params: GetPublisher$Params, context?: HttpContext): Observable<StrictHttpResponse<Publisher>> {
  const rb = new RequestBuilder(rootUrl, getPublisher.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Publisher>;
    })
  );
}

getPublisher.PATH = '/v0/publishers/{id}';
